import * as FileSystem from 'expo-file-system/legacy';

/**
 * Download a remote URL into the app cache directory for local preview (e.g. react-native-pdf).
 */
export async function downloadUrlToTempFile(url: string, suggestedFileName: string): Promise<string> {
  if (url.startsWith('file://') || url.startsWith('content://')) {
    return url;
  }
  const base = FileSystem.cacheDirectory;
  if (!base) {
    throw new Error('Cache directory is not available');
  }
  const safe =
    suggestedFileName.replace(/[^a-zA-Z0-9._-]/g, '_').slice(0, 80) || 'download';
  const path = `${base}tripflow_preview_${Date.now()}_${safe}`;
  const result = await FileSystem.downloadAsync(url, path);
  return result.uri;
}
